<div class="data-filter">
    <label [i18n]="[{target: 'innerHTML', key: labelKey}]" *ngIf="labelKey"></label>
    <ng-select
        [name]="name"
        [items]="options"
        [addTag]="addTagPromise"
        [i18n]="[{target: 'attribute:placeholder', key: placeholderKey},
            {target: 'attribute:notFoundText', key: notFoundTextKey},
            {target: 'attribute:addTagText', key: addTagText}]"
        [hideSelected]="true"
        [multiple]="multiple"
        [required]="required"
        [(ngModel)]="model"
        (change)="change()"
        [appendTo]="'body'">
    </ng-select>
</div>
